<div
style="width: 95%;"
  [attr.dir]="translate.currentLang == 'ar' ? 'rtl' : 'ltr'"
>
  <div
    mat-dialog-title
    class="modal-header-bg d-flex justify-content-end px-3 pt-1"
  ></div>
  <div mat-dialog-content>
    <h4 class="font-weight-bold title-text custom">
      {{ "LimitsonSame-DayRequest" | translate }}
      <span class="check-mark-icon">
        <svg
          class="svg-icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
        >
          <path
            d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
          />
        </svg>
      </span>
    </h4>
    <p class="text-muted-special subtitle-text">
      {{ "request-t0-subtitle" | translate }}
    </p>

    <div class="settings-profile">
      <!-- <div class="stepper-overlay" *ngIf="!selectedAccount">
        <div class="overlay-content">
          {{ "choose-account" | translate }}
        </div>
      </div> -->
      <form #reqT0Form="ngForm" (ngSubmit)="submitReqT0(reqT0Form)">
        <div class="form-row">
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-3">
            <label class="required form-field-title">{{
              "accounts" | translate
            }}</label>
            <ng-select
              [formControl]="selectedAccountControl"
              (ngModelChange)="onAccountChange($event)"
              [searchable]="false"
              class="custom"
              ngModel
              name="RelationCode"
              [dropdownPosition]="'bottom'"
              required
              [placeholder]="'accounts' | translate"
            >
              <ng-option
                *ngFor="let Acc of userAccounts"
                [value]="Acc.relationCode"
              >
                {{
                  translate.currentLang == "en"
                    ? Acc.clientNameEn
                    : Acc.clientNameAr
                }}
              </ng-option>
            </ng-select>
          </div>
          <div class="col-md-12 mb-3" *ngIf="isMaxAmount">
            <div class="d-flex justify-content-end mb-3">
              <button
              class="no-border clickable text-center width-fit yellow-rounded-highlight"
                (click)="withMaxLimit()"
              >
                {{ "without-max-limit" | translate }}
              </button>
            </div>
    
            <div class="alert-div alert-div-warning d-flex flex-wrap mt-2">
              <div class="content-w mx-2 d-flex flex-column align-items-start">
                <div class="d-flex">
                  <div class="icon-w">
                    <img src="assets/img/warning.svg" alt="" />
                  </div>
                  <span class="yellow-text mx-1 font-600">
                    {{ "isMaxLimit-title" | translate }}
                  </span>
                </div>
                <span class="alert-desc-color font-small mx-4 text-start">
                  {{ "isMaxLimit-desc" | translate }}
                </span>
              </div>
            </div>
            
          </div>  
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-6 mb-3" *ngIf="!isMaxAmount">
                <label class="required form-field-title mb-4">{{ "currency" | translate }}</label>
                <ng-select
                  [searchable]="false"
                  class="custom"
                  [(ngModel)]="selectedCurrency"
                  (ngModelChange)="onAccountChange($event)"
                  name="CurrencyId"
                  required
                  [placeholder]="'currency' | translate"
                >
                  <ng-option *ngFor="let curr of currencyList" [value]="curr">
                    {{
                      translate.currentLang == "en"
                        ? curr.CurrencyNameE
                        : curr.CurrencyNameA
                    }}
                  </ng-option>
                </ng-select>
              </div>
          
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-6 mb-3" *ngIf="!isMaxAmount">
            <label class="required form-field-title mb-4">{{ "currency" | translate }}</label>
            <ng-select
              [searchable]="false"
              class="custom"
              [(ngModel)]="selectedCurrency"
              (ngModelChange)="onAccountChange($event)"
              name="CurrencyId"
              required
              [placeholder]="'currency' | translate"
            >
              <ng-option *ngFor="let curr of currencyList" [value]="curr">
                {{
                  translate.currentLang == "en"
                    ? curr.CurrencyNameE
                    : curr.CurrencyNameA
                }}
              </ng-option>
            </ng-select>
          </div>
      
          <div class="col-md-6 mb-3" *ngIf="!isMaxAmount">
            <div class="d-flex align-items-center justify-content-between mb-3">
              <label class="required form-field-title">{{ "enter-cash-amount" | translate }}</label>
              <button
                class="no-border clickable text-center width-fit green-rounded-highlight"
                (click)="withMaxLimit()"
              >
                {{ "with-Max-Limit" | translate }}
              </button>
            </div>
            <div class="custom-position">
              <input
                type="number"
                class="form-control no-spinner"
                id="amount"
                name="amount"
                [(ngModel)]="amount"
                required
                [disabled]="isMaxAmount"
                placeholder="{{ 'enter-cash-amount' | translate }}"
              />
            </div>
          </div>
        </div>
        </div>
            </div>
          </div>
          <div class="col-12 mb-3">
            <label class="required form-field-title">{{
              "request-t0-hint" | translate
            }}</label>
            <p class="text-color-theme">
              {{Endorsement}}
            </p>
          </div>

          <div class="col-12 mb-3">
            <div class="form-check">
              <input
                type="checkbox"
                ngModel
                #endorsementCheck="ngModel"
                name="endorsementCheck"
                id="endorsementCheck"
                required
                class="form-check-input"
              />
              <label
                class="form-check-label px-4 form-field-title"
                for="endorsementCheck"
              >
                {{ "endorsement-check" | translate }}
              </label>
            </div>
          </div>

          <div class="col-12 d-flex justify-content-end">
            <button
              class="btn btn-primary align-self-center mt-4"
              type="submit"
              [disabled]="reqT0Form.invalid || isSubmitting || (!this.isMaxAmount  && this.amount <=0)"
            >
              <span
                *ngIf="isSubmitting"
                class="spinner-border spinner-border-sm"
              ></span>
              {{ "send" | translate }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
